import React, { useCallback } from 'react'
import { NavLink } from 'react-router-dom'
import { Icons } from '@trr/common-component-library'
import { toggleArbetsgivareCookie } from '@trr/app-shell-communication'
import { INavigationRoute } from '@local/src/App.types'

import s from './RoleMenu.module.scss'

interface IRoleMenuProps {
  onClose: () => void
  routes: INavigationRoute[]
  testSelector: string
}

const RoleMenu: React.FunctionComponent<IRoleMenuProps> = ({
  onClose,
  routes = [],
  testSelector,
}) => {
  const onNavLinkClicked = useCallback(
    (url: string) => () => {
      toggleArbetsgivareCookie(url)
      onClose()
    },
    [onClose]
  )

  return (
    <ul className={s.List} data-testid={testSelector}>
      {routes.map(({ name, url, description }) => (
        <React.Fragment key={`role${url.toString()}`}>
          <li>
            <NavLink
              href={url}
              to={url}
              className={s.NavItem}
              onClick={onNavLinkClicked(url)}
              data-testid={`${testSelector}-${name}`}
            >
              <div className={s.NavWrapper}>
                <div className={s.NavHeader}>
                  {name} <Icons.ArrowRightIcon size={16} color="#392b64" />
                </div>
                <div className={s.NavDescription}>{description}</div>
              </div>
            </NavLink>
          </li>
        </React.Fragment>
      ))}
    </ul>
  )
}

export default RoleMenu
